import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Box
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import LocationPicker from './LocationPicker';

const LocationPickerDialog = ({
  open,
  onClose,
  onLocationSelect,
  initialLocation,
  t = {}
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      PaperProps={{
        sx: {
          height: '80vh',
          maxHeight: '700px'
        }
      }}
    >
      <DialogTitle sx={{ m: 0, p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        {t.selectLocation || "Select Location"}
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ p: 2 }}>
        <Box sx={{ height: 'calc(100% - 16px)' }}>
          <LocationPicker
            initialLocation={initialLocation || {}}
            onLocationSelect={onLocationSelect}
            onClose={onClose}
            t={t}
          />
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default LocationPickerDialog;
